import { render, staticRenderFns } from "./DisclaimerQuestion2.vue?vue&type=template&id=777dde80&scoped=true&"
import script from "./DisclaimerQuestion2.vue?vue&type=script&lang=js&"
export * from "./DisclaimerQuestion2.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerQuestion2.vue?vue&type=style&index=0&id=777dde80&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777dde80",
  null
  
)

export default component.exports